/**
 * 簡訊 OTP 的重送倒數秒數（OtpCard、CheckoutPhoneSetup、onboarding NpOtp 共用）。
 *
 * 這個檔原本還有「購物車按前往結帳就先寄簡訊」的 prefetchPhoneOtp。
 * 2026-10-14 第三次拍板：結算頁改成客戶勾協議、按「傳送驗證碼」才寄，預寄移除。
 * 檔名保留，是因為 onboarding 的 NpOtp 也從這裡 import（其他註冊流程零改動）。
 */
export const OTP_RESEND_SECS = 60;
